const fr = {
  translation: {
    //home
    home: "Accueil",
    vehicles: "Véhicules",
    sign_in: "Se connecter",
    plan_you_trip: "Planifiez votre voyage maintenant",
    save_big: "Économisez gros avec notre location de voiture abordable!",
    with_our_car: "avec notre location de voiture abordable!",
    save_big_desc:
      "Louez la voiture de vos rêves. Des prix imbattables, des kilomètres illimités, des options de récupération flexibles et bien plus encore.",
    book_ride: "Réserver une course",
    learn_more: "En savoir plus",
    book_a_car: "Réserver une voiture",
    without_driver: "Sans chauffeur",
    with_driver: "Avec chauffeur",
    select_booking_type: "Sélectionner le type de réservation",
    self_drive: "Conduite autonome",
    tour: "Tour / Location quotidienne",
    transfer_service: "Service de transfert",
    pickup_date: "Date de prise en charge",
    dropoff_date: "Date de restitution",
    pickup_location: "Lieu de prise en charge",
    dropoff_location: "Lieu de restitution",
    book_now: "Réserver maintenant",
    the_price_exclude: "Le prix n'inclut pas les frais du chauffeur, qui seront facturés en supplément",
    select_tour_package: "Sélectionner un forfait touristique",
    select_duration: "Sélectionner la durée",
    destination_location: "Lieu de destination",
    quick_and_easy: "Location de voiture rapide et facile",
    select_car: "Sélectionner une voiture",
    we_offer:
      "Nous proposons une large gamme de véhicules pour tous vos besoins de conduite. Nous avons la voiture parfaite pour répondre à vos besoins",
    contact_operator: "Contacter l'opérateur",
    our_knowlage:
      "Nos opérateurs compétents et amicaux sont toujours prêts à aider avec toutes les questions ou préoccupations",
    let_drive: "Allons-y",
    whether_you:
      "Que vous parcouriez la route ouverte, nous avons ce qu'il vous faut avec notre large gamme de voitures",
    vehicle_models: "Modèles de véhicules",
    our_rental_fleet: "Notre flotte de location",
    choose_from:
      "Choisissez parmi une variété de nos incroyables véhicules à louer pour votre prochaine aventure ou voyage d'affaires",
    reserve_now: "RÉSERVER MAINTENANT",
    save_big_bottom: "Économisez gros avec notre location de voiture bon marché!",
    top_airport: "Principaux aéroports. Fournisseurs locaux. ",
    support: "soutien",
    why_choose_use: "Pourquoi nous choisir",
    best_valued: "Les meilleures offres que vous trouverez jamais",
    discover_the_best:
      "Découvrez les meilleures offres que vous trouverez jamais avec nos offres imbattables. Nous sommes dédiés à vous fournir la meilleure valeur pour votre argent, afin que vous puissiez profiter de services et de produits de haute qualité sans vous ruiner. Nos offres sont conçues pour vous offrir l'expérience de location ultime, alors ne manquez pas votre chance d'économiser gros.",
    find_details: "Trouver des détails",
    cross_city: "Cross City Drive",
    take_your_driving:
      "Poussez votre expérience de conduite à un niveau supérieur avec nos véhicules de première qualité pour vos aventures à travers le pays.",
    all_inclusive: "Prix tout compris",
    get_everything:
      "Obtenez tout ce dont vous avez besoin dans un prix pratique et transparent avec notre politique de tarification tout compris.",
    no_hidden: "Pas de frais cachés",
    enjoy_peace:
      "Profitez de la tranquillité d'esprit avec notre politique sans frais cachés. Nous croyons en une tarification transparente et honnête.",
    review_by_people: "Avis des clients",
    client_testimonial: "Témoignages des clients",
    client_testimonial_desc:
      "Découvrez l'impact positif que nous avons eu sur nos clients en lisant leurs témoignages. Nos clients ont vécu notre service et nos résultats, et ils sont impatients de partager leurs expériences positives avec vous.",
    testi_aris:
      "J'aime vraiment ça. Le service est aussi cool que le chauffeur arrive à l'heure et connaît le chemin. Très content, le service est vraiment cool. La voiture aussi. Ça sent propre et tout se passe bien. Faites en sorte que Mas Yoyok (chauffeur) réussisse et reste en bonne santé, alors oui... Pour un entrepreneur de location de voiture, je ne veux rien dire d'autre. Parce qu'il n'y avait pas de plaintes. Bref, succès.",
    testi_solomon:
      "J'ai loué une Avanza, de type G en 2016. Le véhicule n'avait aucun problème, le moteur était lisse, la carrosserie du véhicule était soigneusement enregistrée, et surtout lorsque vous avez loué le véhicule, l'équipe/groupe WA a été immédiatement préparée... pour les documents demandés... c'est cool. c'est la chose principale.",
    faq: "FAQ",
    frequently_asked: "Questions fréquemment posées",
    frequently_asked_desc:
      "Questions fréquemment posées sur le processus de réservation de location de voiture sur notre site Web : réponses aux préoccupations et questions fréquentes.",
    what_is_special: "1. Qu'est-ce qui rend spécial la comparaison des offres de location de voiture?",
    what_is_special_desc:
      "Comparer les offres de location de voiture est important car cela permet de trouver la meilleure offre qui correspond à votre budget et à vos besoins, vous assurant d'obtenir le meilleur rapport qualité-prix. En comparant différentes options, vous pouvez trouver des offres proposant des prix plus bas, des services supplémentaires ou de meilleurs modèles de voitures. Vous pouvez trouver des offres de location de voiture en faisant des recherches en ligne et en comparant les prix de différentes compagnies de location.",
    how_do_2: "2. Comment puis-je trouver les offres de location de voiture?",
    how_do_2_desc:
      "Vous pouvez trouver des offres de location de voiture en faisant des recherches en ligne et en comparant les prix de différentes compagnies de location. Des sites Web tels qu'Expedia, Kayak et Travelocity vous permettent de comparer les prix et de voir les options de location disponibles. Il est également recommandé de s'inscrire aux newsletters par e-mail et de suivre les compagnies de location de voitures sur les réseaux sociaux pour être informé de toutes les offres spéciales ou promotions.",
    how_do_3: "3. Comment puis-je trouver des prix de location de voiture aussi bas?",
    how_do_3_desc:
      "Réservez à l'avance : La réservation de votre voiture de location à l'avance peut souvent vous permettre d'obtenir des prix plus bas. Comparez les prix auprès de plusieurs compagnies : Utilisez des sites Web tels que Kayak, Expedia ou Travelocity pour comparer les prix auprès de plusieurs compagnies de location de voitures. Recherchez des codes de réduction et des coupons : Recherchez des codes de réduction et des coupons que vous pouvez utiliser pour réduire le prix de la location. La location à un endroit en dehors de l'aéroport peut parfois entraîner des prix plus bas.",
    reservation_12: "Les réservations doivent être faites au moins 12 heures à l'avance",
    reservation_24: "Les réservations doivent être faites au moins 24 heures à l'avance",
    drop_after_pickup: "La date de dépôt doit être après la date de prise en charge",
    //car card
    daily_rate_from: "Tarif journalier à partir de",
    includes: "Comprend",
    isurances_etc: "ASSURANCES, SERVICE CLIENT",
    more_info: "Plus d'informations",
    efficient: "Efficace",
    safe: "Sûr",
    economical: "Économique",
    //select vehicle
    book_car_by_getting: "Réservez une voiture en nous contactant",
    select_vehicle: "Sélectionner un véhicule",
    complete_reservation: "RÉSERVATION COMPLÈTE",
    upon_completing: "Après avoir complété cette demande de réservation, vous recevrez:",
    your_rent_voucher:
      "Votre bon de location à présenter à l'arrivée au guichet de location et un numéro de support client gratuit.",
    location_n_date: "Lieu & Date",
    car: "Voiture",
    pickup_date_n_time: "Date et heure de prise en charge",
    dropoff_date_n_time: "Date et heure de restitution",
    prices: "Prix",
    additional_items: "Articles supplémentaires",
    umbrella: "Parapluie",
    baby_seat: "Siège bébé",
    insurance: "Assurance",
    full_covered: "Assurance tous risques",
    wedding: "Voiture de mariage",
    flower_arrangement: "Arrangement floral (Voiture de mariage)",
    additional_stop: "Arrêt supplémentaire",
    flower_bouquet: "Bouquet de fleurs",
    all_in_one_for: "Péage et stationnement",
    price_estimate: "Estimation du prix",
    estimate_total: "Total estimé",
    the_price_does_not: "Le prix n'inclut les frais de péage, les frais de stationnement, les pourboires.",
    the_price_includes: "Le prix inclut l'essence et le stationnement à sens unique",
    personal_info: "INFORMATIONS PERSONNELLES",
    identity_type: "Type d'identité",
    select_identity: "Sélectionner une identité",
    identity_image: "Image d'identité",
    choose_file: "Choisir un fichier",
    sim_or: "SIM / Permis de conduire",
    name: "Nom",
    booker_name: "Nom du réservateur",
    enter_name: "Entrez votre nom",
    enter_booker_name: "Entrez le nom du client",
    whatsapp_number: "Numéro WhatsApp",
    enter_whatsapp_number: "Entrez votre numéro WhatsApp",
    email: "E-mail",
    enter_email: "Entrez votre adresse e-mail",
    address: "Adresse",
    enter_address: "Entrez votre adresse",
    emergency_contact_1: "Contact d'urgence 1",
    emergency_contact_2: "Contact d'urgence 2",
    enter_emergency: "Entrez votre contact d'urgence",
    return_flight: "Réservation de vol de retour",
    hotel_accomodation: "Hôtel/Hébergement pendant votre séjour",
    notes: "Remarques",
    enter_notes: "Entrez vos notes",
    we_will_ask: "Nous demanderons des données supplémentaires si nécessaire.",
    rental_policy: "Politique de location",
    in_town_usage: "Utilisation en ville",
    add_outside_island: "Ajouter l'utilisation en dehors de l'île",
    outside_island_usage: "Utilisation en dehors de l'île",
    for_self_drive: "Utilisation en dehors de l'île pour la conduite autonome",
    denpasar_jimbaran_etc: "Denpasar, Jimbaran, Legian, Nusa Dua, Uluwatu, Ubud Center, Seminyak.",
    out_of_town_usage: "Utilisation en dehors de la ville",
    zone_1: "Zone 1",
    zone_2: "Zone 2",
    kerobokan_etc:
      "Bangli, Kintamani, Tabanan, Jatiluwih, Canggu, Pererenan, Gianyar (outside ubud center) (frais selon le type de voiture)",
    karangasem_etc: "Amed, Singaraja, Pelataran, Menjangan, Jembrana, Tulamben (frais selon le type de voiture)",
    this_rate_valid: "Ce tarif est valable pour un seul sens seulement.",
    add_out_off_town: "Ajouter une utilisation hors de la ville",
    select_date: "Sélectionner une date",
    select_travel_date: "Sélectionner une date de voyage en dehors de la ville",
    select_travel_date_island: "Sélectionnez une date de voyage en dehors de l'île",
    total: "Total",
    close: "Fermer",
    add: "Ajouter",
    loading: "Chargement...",
    //customer form
    additional_information: "Informations supplémentaires (facultatif)",
    guest_name: "Nom de l'invité",
    driver_name: "Nom du conducteur",
    passanger_total: "Total des passagers",
    luggage_total: "Total des bagages",
    flight_detail: "Détails du vol",
    airline_name: "exemple : nom de la compagnie aérienne : Garuda, heure d'arrivée : 17h00",
    hotel_detail: "Détails de l'hôtel/hébergement",
    hotel_name: "exemple : nom de l'hôtel : indah hotel",
    disability_needs: "Besoins en matière de handicap",
    wheelchair: "exemple : fauteuil roulant : 1",
    the_price_varies: "Le prix varie en fonction de l'emplacement de destination.",
    including_petrol: "Y compris le péage et le stationnement",
    change: "Changer",
    setting_date_use: "Réglage de la date d'utilisation",
    date: "Date",

    // Détail du véhicule
    detail_vehicle: "Détail du véhicule",
    price_type: "Type de prix",
    price: "Prix",
    area: "Zone",
    yes: "Oui",
    trunk: "Coffre",
    customer_service: "SERVICE CLIENT",
    insurances: "ASSURANCES",
    with_a_professional:
      "Avec un service après-vente professionnel et étendu, vous pouvez être tranquille grâce au bon soutien de notre équipe. Vous pouvez également profiter de diverses offres attrayantes et de promotions spéciales en commandant cette voiture.",
    select_this_car: "Sélectionner cette voiture",
    // Global
    save: "Enregistrer",
    big: "grand",
    days: "Jours",
    hour: "Heure",
    brand: "Marque",
    year: "Année",
    seat: "Siège",
    ac: "Climatisation",
    color: "Couleur",
    transmission: "Transmission",
    fuel: "Carburant",
    company: "Entreprise",
    working_hour: "Heures de travail",
    // Confidentialité et politique
    privacy_and_police: "Conditions générales",
    for_overtime:
      "Pour les heures supplémentaires, des frais supplémentaires de Rp 50,000 / heure seront facturés (Les heures supplémentaires dépassant 2 heures seront comptées comme 1 journée d'utilisation).",
    for_extension:
      "Pour prolonger l'unité de location plus de 2 fois, veuillez vérifier et confirmer à notre bureau, Wirasana Rent A Car Denpasar, Jl. Bypass Ngurah Rai No.162, Sanur Kaja, South Denpasar.",
    unit_vehicles:
      "Les unités de véhicules de location ne peuvent pas être transférées/utilisées par quelqu'un d'autre que le locataire qui a signé le contrat de location (Si la voiture est utilisée comme preuve, des frais de location quotidienne seront facturés).",
    reschedule_or:
      "Le report ou le changement de l'emplacement de prise en charge/dépôt de l'unité ne peut pas être confirmé si l'avis est inférieur à 1x24 heures selon le planning de réservation, afin d'éviter les erreurs de configuration opérationnelle.",
    reschedule_date:
      "Pour reporter la date ou l'heure de prise en charge/dépôt de l'unité, des frais de Rp 75,000 seront facturés (maximum 2 reports autorisés).",
    for_lose_umbrella:
      "En cas de perte d'un parapluie pendant la période de location, des frais de Rp 100,000 par parapluie seront facturés.",
    for_lose_baby_seat:
      "En cas de perte d'un siège de bébé pendant la période de location, des frais de Rp 2,000,000 par siège de bébé seront facturés.",
    usage_unit: "L'usage de l'unité est uniquement pour la région de Bali.",
    lose_stnk: "En cas de perte du STNK (immatriculation du véhicule), des frais de Rp 1,500,000 seront facturés.",
    lose_plat: "En cas de perte des plaques d'immatriculation, des frais de Rp 250,000 seront facturés.",
    for_damage_ban:
      "En cas de dommages aux pneus dus à une utilisation inappropriée/utilisation autre que sur des routes asphaltées, des frais de Rp 700,000 par pneu seront facturés.",
    for_beret: "S'il y a de nouvelles égratignures, des frais de Rp 750,000 par incident seront facturés.",
    towing_fee:
      "Les frais de remorquage, et les frais de location de voiture pendant les réparations ne sont pas inclus dans les frais de responsabilité propre.",
    lack_of_petrol:
      "En cas de pénurie de carburant lors de la prise en charge ou du dépôt, des frais de Rp 100,000 par boîte seront facturés.",
    fuel_in_the_middle:
      "Si vous rencontrez une pénurie de carburant en cours de route, des frais de traitement de Rp 250,000 pour les zones dans la ville.",
    smell:
      "S'il y a une odeur de durian/vomi/cigarettes/sièges de voiture mouillés lors du retour de la voiture, des frais de Rp. 1,500,000 seront facturés.",
    dirty_car: "Pour une voiture rendue dans un état très sale, des frais de nettoyage de Rp. 150,000 seront facturés.",
    lost_the_key: "En cas de perte des clés de voiture, des frais de Rp. 1,500,000 seront facturés.",
    more_than_one_driver: "S'il y a plus d'un conducteur, des frais de Rp. 50,000/ID/jour seront facturés.",
    please_not_park:
      "Veuillez ne pas garer le véhicule sous les arbres ou dans des endroits qui pourraient mettre en danger la position du véhicule.",
    charging_error:
      "En cas d'erreur de remplissage de carburant, des frais de réparation de Rp 2,500,000 seront facturés.",
    not_info:
      "Si nous ne recevons pas d'informations liées au besoin d'assistance pour la réparation du véhicule pendant la location, nous n'accepterons pas de remboursement de n'importe quel atelier sans approbation/discussion.",
    trouble_car:
      "En cas de problème avec le véhicule, nos mécaniciens essayeront de faire un suivi et de vous aider dans un délai maximum de 4 heures (selon votre emplacement à ce moment-là).",
    security_deposit:
      "Un dépôt de garantie de Rp 500,000 sera retenu comme garantie pendant la période de location (Le dépôt de garantie sera remboursé par virement bancaire dans un délai maximum de 7 jours après le retour du véhicule et après le contrôle E-Tilang).",
    basic_usage: "L'utilisation de base est limitée à l'intérieur de la ville selon la carte de Traveloka.",
    excess_usage:
      "L'utilisation excessive au-delà de 12 heures ou après minuit entraînera des frais supplémentaires selon l'annexe/règles de Traveloka.",
    driver_contact:
      "Le conducteur vous contactera lorsqu'il sera sur le point d'arriver à l'emplacement de prise en charge.",
    other_questions: "Si vous avez d'autres questions, n'hésitez pas à nous contacter.",
    pickup_point:
      "Le point de prise en charge est devant Solaria, si vous souhaitez demander un autre point de prise en charge, veuillez nous en informer directement via ce groupe.",
    reschedule_info:
      "Les reports ou les changements de lieux de prise en charge et de destination ne peuvent pas être confirmés si l'avis est inférieur à 24 heures avant la réservation prévue, afin d'éviter les erreurs de configuration opérationnelle.",
    reschedule_fee: "Des frais de report de IDR 75,000 seront facturés (maximum de 2 reports).",
    reschedule_airline:
      "Pour les reports dus à des changements d'avion, veuillez joindre une preuve du report, et nous le confirmerons sans frais de report. Cependant, le type de véhicule pour la prise en charge dépendra de la disponibilité du véhicule à l'heure reportée.",
    airline_delay:
      "En cas de retard de l'avion, veuillez fournir une preuve du retard. Notre conducteur fera tout son possible pour venir vous chercher selon le dernier horaire.",
    voucher_usage:
      "Le bon est valable pour une prise en charge unique sans arrêts ou pour un dépôt à sens unique uniquement.",
    additional_stop_meals:
      "Des arrêts supplémentaires pour les repas, etc. entraîneront des frais supplémentaires de IDR 100,000 par heure.",
    driver_wait_time:
      "Le conducteur attendra jusqu'à 30 minutes. S'il dépasse le temps spécifié, des frais supplémentaires de IDR 100,000 par heure seront facturés.",
    destination_change:
      "Des frais supplémentaires seront facturés pour les changements de destination en fonction de l'emplacement.",
    no_eating_drinking:
      "Il est interdit de manger et de boire dans le véhicule si cela peut provoquer des déversements.",
    boarding_landing: "Veuillez confirmer une fois que vous avez embarqué et atterri à l'aéroport de Ngurah Rai.",
    driver_details: "Les détails du conducteur seront fournis le jour du voyage.",
    mask_and_distance: "Veuillez toujours porter un masque et maintenir la distance sociale à l'intérieur du véhicule.",
    disinfected_vehicles: "Tous les véhicules Wirasana ont été désinfectés au préalable.",
    SWAB_driver_charge: "Frais supplémentaires pour le test SWAB du conducteur : IDR 99,000 (si nécessaire).",
    passenger: "Passager",
    use_the_current_location: "Utiliser l'emplacement actuel",
    cancel: "Annuler",
    confirm: "Confirmer",
    i_have_read_and_accept: "J'ai lu et j'accepte la politique de confidentialité",
    i_accept_the_privacy: "J'accepte la politique de confidentialité",
    open_filters: "Ouvrir les filtres",
    sort: "Trier",
    price_low_to_high: "Prix : du plus bas au plus élevé",
    price_high_to_low: "Prix : du plus élevé au plus bas",
    name_a_z: "Nom : A → Z",
    name_z_a: "Nom : Z → A",
    filters: "Filtres",
    price_per_day: "Prix par jour",
    total_passenger: "Nombre total de passagers",
    drivetrain: "Transmission intégrale",
    clear_all: "Tout effacer",
    apply_filters: "Appliquer les filtres",
    search_car: "Rechercher une voiture",
    ready_to_continue_payment: "Prêt à continuer le paiement ?",
    please_review_payment: "Veuillez vérifier vos informations de paiement avant de continuer.",
    total_amount: "Montant total à payer",
    proceed_to_payment: "Procéder au paiement",
    about: "À propos",
    about_company: "À propos de l'entreprise",
    about_headline: "Démarrez le moteur et votre aventure commence",
    about_description:
      "Simple mais dévoué, nous offrons le meilleur service pour rendre chaque voyage confortable, sûr et mémorable.",
    about_car_types: "Types de voitures",
    about_rental_outlets: "Agences de location",
    about_repair_shop: "Ateliers de réparation",
    about_book_car: "Réservez une voiture en nous contactant",
    about_phone: "(0361) 286-066",
    language: "Langue",
    about_us: "À propos de nous",
    contact_us: "Contactez-nous",
    booking_type: "Type de Réservation",
    the_royal_essence: "L'essence Royale du Voyage",
    relaxed_journey: "VOYAGE LE PLUS DÉTENDU",
    page_title: "Contact",
    headline: "Besoin d'informations supplémentaires?",
    description:
      "Un professionnel polyvalent avec plus de 15 ans d'expérience en recherche, développement et enseignement.",
    phone_label: "Téléphone",
    email_label: "Email",
    address_label: "Adresse",
    form_name: "Nom complet",
    form_message: "Parlez-nous de votre demande",
    form_placeholder_name: "Ex: 'Jean Dupont'",
    form_placeholder_message: "Écrivez ici...",
    form_button: "Envoyer via WhatsApp",
    required_alert: "Veuillez remplir tous les champs obligatoires!",
    address_value: "Denpasar, Bali",
    why_choose_wirasana: "Pourquoi choisir Wirasana",
    trusted_partner: "Votre partenaire de confiance pour la location de voiture à Bali",
    experience_excellence:
      "Découvrez l’excellence avec notre flotte premium, notre service exceptionnel et nos prix imbattables.",
    happy_customers: "Clients satisfaits",
    vehicles_available: "Véhicules disponibles",
    years_experience: "Années d’expérience",
    satisfaction_rate: "Taux de satisfaction",
    what_makes_us_different: "Ce qui nous rend différents",
    discover_advantages: "Découvrez les avantages qui nous distinguent de la concurrence",
    comprehensive_insurance: "Assurance complète",
    comprehensive_insurance_desc:
      "Une assurance tous risques incluse dans chaque location pour une tranquillité d’esprit totale.",
    premium_fleet: "Flotte Premium",
    premium_fleet_desc: "Des véhicules modernes et bien entretenus pour une expérience de conduite optimale.",
    support_247: "Assistance 24h/24 et 7j/7",
    support_247_desc: "Service client disponible à tout moment pour vous aider.",
    best_price: "Garantie du meilleur prix",
    best_price_desc: "Tarifs transparents et compétitifs, sans frais cachés.",
    flexible_rental: "Location flexible",
    flexible_rental_desc: "Choisissez la durée de location qui vous convient, de l’heure au mois.",
    free_delivery: "Livraison gratuite",
    free_delivery_desc: "Livraison et récupération gratuites du véhicule à l’endroit de votre choix à Bali.",
    more_reasons: "Plus de raisons de nous faire confiance",
    trusted_by_thousands: "Approuvé par des milliers de clients",
    trusted_by_thousands_desc:
      "Plus de 10 000 clients satisfaits nous ont choisis pour leurs besoins de transport à Bali.",
    licensed_insured: "Autorisé et assuré",
    licensed_insured_desc: "Flotte entièrement autorisée et assurée pour votre sécurité.",
    easy_booking: "Réservation facile",
    easy_booking_desc: "Réservez en ligne en quelques minutes sans paperasse compliquée.",
    flexible_payment: "Options de paiement flexibles",
    flexible_payment_desc: "Nous acceptons les cartes de crédit, virements et portefeuilles électroniques.",
    cta_title: "Prêt à commencer votre voyage ?",
    cta_desc: "Réservez votre véhicule idéal aujourd’hui et découvrez la différence Wirasana.",
    call_us_now: "Appelez-nous maintenant",
    back: "Dos",
    weather_protection: "Protection contre les intempéries pour les activités en plein air",
    safety_seat_children: "Siège de sécurité pour enfants (5–4 ans)",
    beautiful_flower_arrangements: "Magnifiques arrangements floraux pour des occasions spéciales",
    extra_stops: "Arrêts supplémentaires pendant votre voyage",
    all_in_one_package: "Forfait tout-en-un pour plus de commodité",
    fresh_flower_bouquet: "Arrangement de bouquet de fleurs fraîches",
    set_quantity_each_date: "Définir la quantité pour chaque date",
    total_items: "Articles totaux",
    items: "Articles",
    select_all: "Tout sélectionner",
    select_dates_apply_item: "Sélectionnez les dates auxquelles appliquer cet article",
    item_will_be_applied: "L’article sera appliqué",
    out_of: "sur",
    total_day: "jours au total",
    type_or_choose_location: "Saisissez un lieu ou choisissez dans la liste...",
    select_from_map: "Sélectionner un lieu sur la carte",
    popular_locations: "Lieux populaires",
    manual_input_hint: "Ou saisissez le lieu manuellement dans la barre de recherche",
    common: {
      back: "Dos",
      back_to_search: "Retour à la recherche",
      name: "Nom",
      email: "E-mail",
      phone: "Téléphone",
      total: "Total",
      hours: "Heures",
      processing: "Traitement...",
      searching: "Recherche...",
      error_occurred: "Une erreur s'est produite. ",
      information: "Information",
    },
    booking: {
      detail: "Détails de la réservation",
      booking_number: "Numéro de réservation{{number}}",
      not_found: "Données introuvables",
      search_again: "Veuillez rechercher à nouveau votre réservation",
      type: "Type de réservation",
      pickup_date: "Date de ramassage",
      dropoff_date: "Date de dépôt",
      price_breakdown: "Répartition des prix",
      price_date: "Prix ​​({{date}})",
      fees: "Frais de transaction et taxes",
      delivery_fee: "Frais de livraison",
      pickup_fee: "Frais de ramassage",
      canceled: "Commande annulée",
      contact_customer_service: "Cette commande a été annulée. ",
      check_history: "Vérifier l'historique des réservations",
      enter_details: "Entrez votre e-mail et votre code de réservation pour afficher les détails de votre commande",
      booking_code: "Code de réservation",
      code_example: "Exemple : S-0018, T-0025 (utilisez S-0018 pour la démonstration)",
      check_booking: "VÉRIFIER LA RÉSERVATION",
      info_code_sent: "Le code de réservation est envoyé à votre email après la réservation",
      info_continue_payment: "Vous pouvez continuer le paiement des commandes impayées",
      info_contact_support: "Contactez le service client si vous rencontrez des problèmes",
    },
    status: {
      booked: "Réservé",
      prepared: "Préparé",
      operated: "Exploité",
      canceled: "Annulé",
      success: "Succès",
    },
    payment: {
      not_paid: "Non payé",
      paid: "Payé",
      partial: "Paiement partiel",
      continue: "CONTINUER LE PAIEMENT",
      invoice_not_found: "Facture introuvable",
      link_failed: "Échec de la création du lien de paiement. ",
      received: "Paiement reçu",
      total_paid: "Total payé : {{amount}}",
    },
    validation: {
      fill_all_fields: "Veuillez remplir l'e-mail et le code de réservation",
    },
    manage_booking: "Gérer la réservation",
    booking_confirmation: "Confirmation de réservation",
    next: "Suivant",
    booking_details: "Détails de la réservation",
    review_n_confirm: "Vérifier et confirmer",
    booking_success: "Réservation réussie !",
    booking_success_message: "Votre réservation a été soumise avec succès. ",
    open_payment_link: "Ouvrir le lien de paiement",
    required_documents: "Documents requis",
    payment_information: "Informations de paiement",
    review_payment_details: "Veuillez vérifier vos informations de paiement et procéder au paiement",
    booking_summary: "Récapitulatif de la réservation",
    invoice_number: "Numéro de facture",
    customer_name: "Nom du client",
    payment_instructions: "Instructions de paiement",
    payment_instruction_1: "Cliquez sur le bouton ci-dessous pour créer une facture de paiement",
    payment_instruction_2: "Vous serez redirigé vers la page de paiement Xendit",
    payment_instruction_3: "Complétez votre paiement en utilisant les méthodes de paiement disponibles",
    payment_instruction_4: "Vous recevrez un e-mail de confirmation après le paiement réussi",
    payment_link_created: "Le lien de paiement a été créé !",
    click_below_to_proceed: "Cliquez sur le bouton ci-dessous pour procéder au paiement",
    creating_invoice: "Création d'une facture...",
    create_payment_invoice: "Créer une facture de paiement",
    done: "J'ai complété le paiement",
    order_summary: "Récapitulatif de la commande",
    please_review_order: "Veuillez vérifier les détails de votre commande avant de procéder au paiement",
    customer_information: "Informations client",
    phone: "Téléphone",
    vehicle: "Véhicule",
    rental_period: "Période de location",
    locations: "Lieux",
    price_breakdown: "Détail des prix",
    base_price: "Prix de base",
    delivery_fee: "Frais de livraison",
    pickup_fee: "Frais de récupération",
    tour_package: "Prix des forfaits touristiques à partir de",
    airport_transfer_from: "Prix du service de transfert aéroportuaire à partir de",
    tourPackage: "Forfait Touristique",
    basic_title: "Protection de base",
    basic_subtitle: "Couverture de base incluse dans votre location",
    km_unlimited: "Kilométrage illimité",
    own_risk: "Avec frais de risque propre de 750 000 Rp par incident",
    damage_cover: "Couverture pour les collisions, les rayures et les dommages causés par un impact",
    glass_tire: "Protection des pneus et des vitres",
    interior_protect: "Protection intérieure",
    not_included_towing:
      "N'inclut pas le service de remorquage et les jours de location supplémentaires si la réparation dure plus de 7 jours",
    got_it: "J'ai compris",
    basic_protection: "Protection de base",
    see_more_details: "Voir plus de détails",
    gps: "GPS",
    gps_desc: "Système de navigation embarqué.",
    phone_holder: "Support Téléphone",
    phone_holder_desc: "Support mains libres pour une conduite sûre.",
    family_card: "Carte de Famille",
    business_id: "Identifiant Professionnel",
    social_media: "Réseaux Sociaux",
    customer_info: "Informations Client",
    enter_social_media: "Saisir les réseaux sociaux",
    insurance_subtitle: "Protégez votre voyage avec une couverture complète et une tranquillité d'esprit",
    included: "Compris",
    not_included: "Non inclus",
    toll_and_parking: "Péage et Stationnement",
    toll_and_parking_desc: "Frais péage et parking",
    your_trusted_mobility: "Votre partenaire de mobilité de confiance à Bali",
    wirasana_is_professional:
      "Wirasana Rent A Car est un service de location de voitures professionnel basé à Bali, dédié à fournir des solutions de transport fiables, confortables et flexibles pour les voyageurs et les entreprises. Avec des années d'expérience dans l'industrie du transport, nous comprenons que la mobilité est une partie essentielle de chaque voyage – que ce soit pour les loisirs, les affaires ou les occasions spéciales.",
    our_mission_is_to_make:
      "Notre mission est de rendre le transport à Bali simple, sûr et accessible. Nous offrons une large gamme de véhicules bien entretenus pour répondre à différents besoins, des voitures compactes pour les voyages personnels aux véhicules premium pour les affaires et les événements spéciaux.",
    lets_get_you: "Mettons-vous en route",
    have_questions_about:
      "Vous avez des questions sur nos véhicules, nos prix ou leur disponibilité ? Notre équipe est prête à vous aider. Que vous planifiez des vacances à Bali, un voyage d'affaires ou un événement spécial, nous sommes là pour rendre votre expérience de transport fluide et sans tracas.",
    search_vehicle: "Rechercher un véhicule",
    vehicle_type: "Type de véhicule",
    motorcycle: "Moto",
    all: "Tous",
    your_trustedcar_rental_in_bali: "Votre location de voiture de confiance à Bali",
    simple_booking: "Réservation simple. Véhicules fiables. Service exceptionnel.",
    we_provide_flexible:
      "Nous proposons des solutions de location flexibles, y compris la location sans chauffeur, le service avec chauffeur et les transferts aéroport, le tout conçu pour rendre votre voyage à Bali sans effort.",
  },
};

export default fr;
